<template>
  <div class="selector">
    <!-- エリア選択 -->
    <ul class="selector__tabs">
      <li
        class="selector__tabs__item"
        v-for="area in data.areas"
        :key="area.id"
      >
        <button
          :class="area.id === selectedArea.id && 'is-current'"
          @click="changeArea(area)"
        >
          <span>
            <ThumbAreaCap :name="area.slug" :current="area.id === selectedArea.id" />
          </span>
          {{ area.name }}
        </button>
      </li>
    </ul>
    <!-- パーツ選択 -->
    <ul class="selector__subTabs">
      <li
        class="selector__subTabs__item"
        v-for="part in currentParts"
        :key="part.id"
      >
        <button
          :class="`${ isPartSelected(part) && 'is-selected' }`"
          @click="handleChangePart(part)"
        >
          <span>
            <ThumbPartCap :name="part.slug" :current="isPartSelected(part)" />
          </span>
          {{ part.name }}
        </button>
      </li>
    </ul>
    <div class="selector__wrapper">
      <div class="selector__container">

        <!-- バイザー -->
        <template v-if="selectedArea.slug === 'visor'">

          <!-- レイヤー1： バイザー - 形 -->
          <template v-if="isContainPartSlug('visor_form')">
            <div class="items items--capElements" v-if="visorFormItems.length">
              <div class="items__item" v-for="item in visorFormItems" :key="item.id">
                <button
                  :class="`items__button ${ selectedVisorFormItem.id === item.id && 'is-selected' }`"
                  @click="changeVisorFormItem(item)"
                >
                  <span class="items__thumb"><CapElementImage :name="item.slug" /></span>
                  <span class="items__name">{{ item.name }}</span>
                </button>
              </div>
            </div>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedVisorFormItemColor === null && 'is-selected' }`"
                  @click="changeVisorFormItemColor(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedVisorFormItemColor === color && 'is-selected' }`"
                  @click="changeVisorFormItemColor(color)"
                >
                </button>
              </div>
            </div>
            <div class="items items--textures">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedVisorFormItemTexture === null && 'is-selected' }`"
                  @click="changeVisorFormItemTexture(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="texture in textures" :key="texture">
                <button
                  :class="`items__button ${ selectedVisorFormItemTexture && selectedVisorFormItemTexture === texture && 'is-selected' }`"
                  @click="changeVisorFormItemTexture(texture)"
                >
                  <img :src="`/simulator/images/cap/texture_icon_${ texture }.svg`" alt="">
                </button>
              </div>
            </div>
          </template>

          <!-- レイヤー2： バイザー - バイザーライン -->
          <template v-if="isContainPartSlug('visor_line')">
            <div class="items items--capElements" v-if="visorLineItems.length">
              <div class="items__item" v-for="item in visorLineItems" :key="item.id">
                <button
                  :class="`items__button ${ selectedVisorLineItem.id === item.id && 'is-selected' }`"
                  @click="changeVisorLineItem(item)"
                >
                  <span class="items__thumb"><CapElementImage :name="item.slug" /></span>
                  <span class="items__name">{{ item.name }}</span>
                </button>
              </div>
            </div>
            <div v-if="selectedVisorLineItem.slug === 'visor_line_on'" class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedVisorLineItemColor === null && 'is-selected' }`"
                  @click="changeVisorLineItemColor(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedVisorLineItemColor === color && 'is-selected' }`"
                  @click="changeVisorLineItemColor(color)"
                >
                </button>
              </div>
            </div>
          </template>
        </template>

        <!-- クラウン -->
        <template v-if="selectedArea.slug === 'crown'">

          <!-- レイヤー3： クラウン - 正面 -->
          <div v-if="isContainPartSlug('crown_front')" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCrownFrontColor === null && 'is-selected' }`"
                @click="changeCrownFrontColor(null)"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCrownFrontColor === color && 'is-selected' }`"
                @click="changeCrownFrontColor(color)"
              >
              </button>
            </div>
          </div>

          <!-- レイヤー4： クラウン - サイドバック -->
          <div v-if="isContainPartSlug('crown_back')" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCrownBackColor === null && 'is-selected' }`"
                @click="changeCrownBackColor(null)"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCrownBackColor === color && 'is-selected' }`"
                @click="changeCrownBackColor(color)"
              >
              </button>
            </div>
          </div>

          <!-- レイヤー5： クラウン - 穴がかり -->
          <div v-if="isContainPartSlug('crown_hole')" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCrownHoleColor === null && 'is-selected' }`"
                @click="changeCrownHoleColor(null)"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCrownHoleColor === color && 'is-selected' }`"
                @click="changeCrownHoleColor(color)"
              >
              </button>
            </div>
          </div>

          <!-- レイヤー6： クラウン - 天ボタン -->
          <div v-if="isContainPartSlug('crown_button')" class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ selectedCrownButtonColor === null && 'is-selected' }`"
                @click="changeCrownButtonColor(null)"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ selectedCrownButtonColor === color && 'is-selected' }`"
                @click="changeCrownButtonColor(color)"
              >
              </button>
            </div>
          </div>
        </template>

        <!-- レイヤー7: マーク -->
        <template v-if="selectedArea.slug === 'mark'">
          <div class="items items--markOneSideItems">
            <div class="items__item" v-for="item in markItems" :key="item.id">
              <button
                @click="changeMarkItem(item)"
                :class="`items__button ${ item.id === selectedMarkItem.id && 'is-selected' }`"
                :style="{ backgroundColor: item.background_color }"
              >
                <span class="items__thumb"><CapMarkItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section v-if="selectedMarkItem.color1" class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedMarkItemColor1 === null && 'is-selected' }`"
                  @click="changeMarkItemColor1(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedMarkItemColor1 === color && 'is-selected' }`"
                  @click="changeMarkItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
           <section v-if="selectedMarkItem.color2" class="selectorSection">
            <h3 class="selectorSection__name">カラー2</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedMarkItemColor2 === null && 'is-selected' }`"
                  @click="changeMarkItemColor2(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedMarkItemColor2 === color && 'is-selected' }`"
                  @click="changeMarkItemColor2(color)"
                >
                </button>
              </div>
            </div>
          </section>
           <section v-if="selectedMarkItem.color3" class="selectorSection">
            <h3 class="selectorSection__name">カラー3</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedMarkItemColor3 === null && 'is-selected' }`"
                  @click="changeMarkItemColor3(null)"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedMarkItemColor3 === color && 'is-selected' }`"
                  @click="changeMarkItemColor3(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThumbAreaCap from '../images/thumb/area/cap/ThumbAreaCap'    // キャップのエリア画像
import ThumbPartCap from '../images/thumb/part/cap/ThumbPartCap'    // キャップのパーツ画像
import CapElementImage from '../images/item/CapElementImage'
import CapMarkItemImage from '../images/item/CapMarkItemImage'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    ThumbAreaCap,
    ThumbPartCap,
    CapElementImage,
    CapMarkItemImage
  },
  computed: {
    ...mapState({
      data: state => state.cap.data,
      colors: state => state.cap.colors,
      textures: state => state.cap.textures,
      selectedArea: state => state.cap.selectedArea,
      selectedPart: state => state.cap.selectedPart,
      selectedVisorFormItem: state => state.cap.selectedVisorFormItem,
      selectedVisorFormItemColor: state => state.cap.selectedVisorFormItemColor,
      selectedVisorFormItemTexture: state => state.cap.selectedVisorFormItemTexture,
      selectedVisorLineItem: state => state.cap.selectedVisorLineItem,
      selectedVisorLineItemColor: state => state.cap.selectedVisorLineItemColor,
      selectedCrownFrontColor: state => state.cap.selectedCrownFrontColor,
      selectedCrownBackColor: state => state.cap.selectedCrownBackColor,
      selectedCrownHoleColor: state => state.cap.selectedCrownHoleColor,
      selectedCrownButtonColor: state => state.cap.selectedCrownButtonColor,
      selectedMarkItem: state => state.cap.selectedMarkItem,
      selectedMarkItemColor1: state => state.cap.selectedMarkItemColor1,
      selectedMarkItemColor2: state => state.cap.selectedMarkItemColor2,
      selectedMarkItemColor3: state => state.cap.selectedMarkItemColor3,
    }),
    currentParts: function() { 
      return this.data.parts.filter(part => part.area_id === this.selectedArea.id)
    },
    visorFormItems: function() { 
      return this.data.items.visor_form
    },
    visorLineItems: function() { 
      return this.data.items.visor_line
    },
    markItems: function() { 
      return this.data.items.mark
    },
  },
  watch: {
    selectedElement() {
      this.selectedElement.forEach(element => {
        if (element.slug === 'visor_line_off') {
          this.changeVisorLineItemColor(null)
        }
      })
    }
  },
  methods: {
    ...mapMutations({
      changeArea: 'cap/changeArea',
      changePart: 'cap/changePart',
      changeElement: 'cap/changeElement',
      changeVisorFormItem: 'cap/changeVisorFormItem',
      changeVisorFormItemColor: 'cap/changeVisorFormItemColor',
      changeVisorFormItemTexture: 'cap/changeVisorFormItemTexture',
      changeVisorLineItem: 'cap/changeVisorLineItem',
      changeVisorLineItemColor: 'cap/changeVisorLineItemColor',
      changeCrownFrontColor: 'cap/changeCrownFrontColor',
      changeCrownBackColor: 'cap/changeCrownBackColor',
      changeCrownHoleColor: 'cap/changeCrownHoleColor',
      changeCrownButtonColor: 'cap/changeCrownButtonColor',
      changeMarkItem: 'cap/changeMarkItem',
      changeMarkItemColor1: 'cap/changeMarkItemColor1',
      changeMarkItemColor2: 'cap/changeMarkItemColor2',
      changeMarkItemColor3: 'cap/changeMarkItemColor3',
    }),
    handleChangePart: function(part) {
      this.changePart(part)
    },
    isPartSelected: function(_part) {
      return this.selectedPart.some(part => part.id === _part.id)
    },
    isContainPartSlug: function(slug) {
      return this.selectedPart.find(part => part.slug === slug)
    },
  }
}
</script>